import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
      
        html {
                box-sizing: border-box;
                font-family: 'Open Sans', sans-serif;
                background: #F6F6F6;
        }
        
        *, *::before, *::after {
                box-sizing: inherit;
        }
        
        ul, li, h1, h2, h3, p, button { 
                margin: 0;
        }

        ul {
                list-style: none;
        }

        .linkDescarga{
                color:#D9A76A
        }

        button {
                background: transparent;
                border: 0;
                outline: 0;
        }

        body {
                background: #F6F6F6;
                height: 100vh;
                margin: 0 auto;
                overscroll-behavior: none;
                width: 100%;
        }

        #app {
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
                overflow-x: hidden;
                min-height: 100vh;
                padding-bottom: 10px;
        }
        .botonTextarea{
                background: #D9A76A;
                color: #fff;
                margin-left: 0px;
                border-radius: 4px;
                border: #D9A76A solid 1px;
                display: -webkit-inline-box;
                display: -webkit-inline-flex;
                display: -ms-inline-flexbox;
                display: inline-flex;
                text-transform: uppercase;
                cursor: pointer;
                margin-right: 13px;
                font-size: 12px;
                padding: 4px 8px;  
        }
        `
        

        